import { styled } from '@stitches/configed';
import Input from 'antd/lib/input';
import { FC, HTMLProps, useState } from 'react';
import SearchIcon from '../Icons/SearchIcon';

const InputStyled = styled(Input, {
  display: 'block',
  width: '100%',
  padding: '0.375rem 0.75rem',
  borderRadius: '1.25rem',
  transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
  background: '$white',
  border: '1px solid $border',
  color: '$dark',
  height: 56,

  '&:focus': {
    borderColor: '$brand',
  },
  '&:hover,&:focus,&.active': {
    boxShadow: 'none',
    background: '$white',
    color: '$dark',
  },
});
const InputSearchWrapper = styled('div', {
  minHeight: 40,
  // borderRadius: 100,
  borderRadius: 10,
  // border: '1px solid $border',
  border: '1px solid $border',
  boxShadow: '0px 12px 23px rgba(62, 73, 84, 0.04)',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#fff',
  paddingRight: 16,
  transition: 'all .3s',
  '&:hover,&:focus,&.active': {
    borderColor: '$brand',
  },
  '@xs': {
    // borderRadius: 5,
  },
  variants: {
    focusing: {
      true: {
        borderColor: '$brand',
      },
    },
    iconFirst: {
      true: {
        paddingLeft: 16,
        input: {
          paddingLeft: 10,
        },
      },
    },
  },

  input: {
    padding: '0px 16px',
    marginBottom: '-2px',
    width: '100%',
    outline: 'none',
    backgroundColor: 'transparent',
    '&:hover,&:focus,&.active': {
      boxShadow: 'none',
    },
    '&::placeholder': {
      color: '$content-tertiary',
    },
  },
  svg: {
    fontSize: 20,
  },
});

type Props = HTMLProps<HTMLInputElement> & {
  iconFirst?: boolean;
};
export const InputSearch: FC<Props> = ({ iconFirst, style, ...props }) => {
  const [focusing, setFocusing] = useState(false);
  return (
    <InputSearchWrapper focusing={focusing} iconFirst={iconFirst} style={style}>
      {iconFirst && <SearchIcon />}
      <input
        {...props}
        onFocus={() => setFocusing(true)}
        // onMouseOver={() => setFocusing(true)}
        // onMouseOut={() => setFocusing(false)}
        onBlur={() => setFocusing(false)}
      />
      {!iconFirst && <SearchIcon />}
    </InputSearchWrapper>
  );
};
export default InputStyled;
